// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b7169f1b","453":"0a36081d"}[chunkId] + ".chunk.js";
};